import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  makeStyles,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
  modalHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    '& h1': {
      fontSize: 20,
      fontWeight: 400,
      margin: theme.spacing(0.5),
      ...theme.headerFont,
    },
  },
  closeBtn: {
    width: 40,
    height: 40,
  },
  modalBody: {
    width: '100%',
  },
}))

const ModalSp = ({ children, open, onClose, ariaLabelledby="modal", title=false, className=false, contentClassName=null, fullScreen=false, maxWidth = "md" }) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={ariaLabelledby}
      maxWidth={maxWidth}
      scroll="paper"
      className={className ? className:''}
      fullScreen={fullScreen}
    >
      <DialogTitle>
        <div className={classes.modalHeader}>
          {title ? <h1>{title}</h1>:<div/>}
          <IconButton classes={{ root: classes.closeBtn }} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <div className={`${classes.modalBody} ${contentClassName}`}>{children}</div>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSp
